/* Optional enhancement: whole-card click without nesting anchors. */
document.addEventListener('click', function (event) {
  var card = event.target.closest('[data-adorb-service-card]');
  if (!card || event.target.closest('a, button')) return;
  var url = card.getAttribute('data-url');
  if (url) window.location.href = url;
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  var card = event.target.closest('[data-adorb-service-card]');
  if (!card || event.target.closest('a, button')) return;
  var url = card.getAttribute('data-url');
  if (url) {
    event.preventDefault();
    window.location.href = url;
  }
});
